




































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import DatePicker from "@/components/DatePicker.vue";
import moment from "moment";
import app from "@/store/app";
import reward from "@/store/reward";
import analytics from "@/store/analytics";
import { formatRate, formatNumber, formatTextToNumber } from "@/utils/format";

@Component({ components: { DatePicker } })
export default class RewardData extends Vue {
  public startDate = moment()
    .subtract(7, "days")
    .format("YYYY-MM-DD");
  public endDate = moment().format("YYYY-MM-DD");

  public dialog1 = false;
  public dialog2 = false;
  public dialog3 = false;

  get rewardData() {
    return reward.summaryData;
  }

  get analyticData() {
    return analytics.summaryData;
  }

  get accountAdmin() {
    return analytics.account_admin;
  }

  get dateRangeTotal() {
    return reward.dateRangeTotal;
  }

  public onRewardDetailClick() {
    this.$router.push("/reward-details");
  }

  public onDataDetailClick() {
    this.$router.push("/data-details");
  }

  public formatConversionRate(rate: number | string) {
    return formatRate(rate);
  }

  public formatNumber(number: number) {
    return formatNumber(number);
  }

  public formatTextToNumber(text: string) {
    return formatTextToNumber(text);
  }

  public mounted() {
    this.getRewardAndData();
  }

  public async getRewardAndData() {
    try {
      app.SET_IS_LOADING(true);
      const payload = {
        startdate: this.startDate,
        enddate: this.endDate
      };

      await Promise.all([
        analytics.getAnalyticSummaryData(payload),
        reward.getRewardSummaryData(),
        reward.getLocaleInfo(),
        analytics.getAccountAdmin()
      ]);

      await reward.getRewardActivityData(payload);

      app.SET_IS_LOADING(false);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.alert("因账号权限原因，你目前无法查看此页面内容");
        app.SET_HAS_ERROR();
      }
    }
  }

  public updateStartDate(date: string) {
    this.startDate = date;
  }

  public updateEndDate(date: string) {
    this.endDate = date;
  }
}
